const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    marginRight: 6,
  },
});

export default styles;
